import { PlusOutlined } from '@ant-design/icons';
import type { ButtonProps } from 'antd';
import { Button } from 'antd';

export type Props = Omit<ButtonProps, 'icon' | 'type'> & {
  icon?: ButtonProps['icon'];
};

/**
 * Shared add-action button with the application's primary treatment.
 */
const AddButton = ({ children, icon, ...props }: Props) => (
  <Button
    {...props}
    icon={icon ?? <PlusOutlined aria-hidden='true' />}
    type='primary'>
    {children}
  </Button>
);

export default AddButton;
